import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=24ea7b33&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"
import style0 from "./CreatePassword.vue?vue&type=style&index=0&id=24ea7b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea7b33",
  null
  
)

export default component.exports